export enum TagColor {
  Green,
  Purple,
  Yellow,
  Blue,
}
